/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path api
 * @description Backend API
 */
import axios from "axios";
import Query from "./../querybuilder/Query";

const modelCache:
  | {
      key: { id: string; name: string }[];
    }
  | {} = {};

const topElementCache = new Map<string, Promise<any[]>>();

export const getModel = async (
  id: string
): Promise<
  {
    id: string;
    name: string;
  }[]
> => {
  const queryParams = {
    query: `[SC.${id}]`,
    attributes: "id, name",
  };
  const cacheKey = JSON.stringify(queryParams);
  if (modelCache.hasOwnProperty(cacheKey)) return (modelCache as any)[cacheKey];

  const response = await axios.post("meaquery", queryParams);
  const result =
    response.data?.data && Array.isArray(response.data.data)
      ? response.data.data
      : [];

  (modelCache as any)[cacheKey] = result;
  return result;
};

export const getTopElement = async (
  modelId: string,
  scorecardSymbol: string,
  attributes: string
): Promise<any[]> => {
  const queryParams = {
    query: `[SC.${modelId}].scorecard(criteria="symbol=\\\"${scorecardSymbol}\\\"").topelement`,
    attributes,
  };
  const cacheKey = JSON.stringify(queryParams);
  const cached = topElementCache.get(cacheKey);
  if (cached) {
    return cached;
  }

  const request = axios
    .post("meaquery", queryParams)
    .then((response) => {
      return response.data?.data && Array.isArray(response.data.data)
        ? response.data.data
        : [];
    })
    .catch((error) => {
      topElementCache.delete(cacheKey);
      throw error;
    });

  topElementCache.set(cacheKey, request);
  return request;
};

export const getSeries = async (
  modelId: string
): Promise<
  {
    id: string;
    name: string;
    symbol: string;
    pathtype: string;
  }[]
> => {
  return Query(modelId)
    .series()
    .attributes("name", "symbol", "pathtype")
    .fetchValues();
};
export const getPeriods = async (
  modelId: string
): Promise<
  {
    id: string;
    name: string;
    startdate: string;
    enddate: string;
    periodlevel: string;
  }[]
> => {
  return Query(modelId)
    .period()
    .attributes(
      "name",
      "startdate",
      "enddate",
      "periodlevel",
      "periodlevelname"
    )
    .sortBy("-enddate")
    .fetchValues();
};
export const getPeriodLevels = async (
  modelId: string
): Promise<
  {
    id: string;
    name: string;
    periodleveltype: string;
  }[]
> => {
  return Query(modelId)
    .periodlevel()
    .attributes("name", "periodleveltype")
    .sortBy("-enddate")
    .fetchValues();
};
export const getKPIs = async (
  modelId: string
): Promise<
  {
    id: string;
    name: string;
    startdate: string;
    enddate: string;
    periodlevel: string;
  }[]
> => {
  return Query(modelId)
    .KPI({
      criteria: {
        hasreferencescorecard: "0",
      },
    })
    .attributes("name")
    .fetchValues();
};
